import { useState } from 'react'
import { supabase } from '../../lib/supabase'
import { Eye, EyeOff, Check } from 'lucide-react'
import AuthShell from '../../components/AuthShell'

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('')
  const [confirm,  setConfirm]  = useState('')
  const [show,     setShow]     = useState(false)
  const [saving,   setSaving]   = useState(false)
  const [done,     setDone]     = useState(false)
  const [error,    setError]    = useState('')

  async function handleReset(e) {
    e.preventDefault()
    setError('')
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return }
    if (password !== confirm) { setError("Passwords don't match."); return }
    setSaving(true)
    const { error: err } = await supabase.auth.updateUser({ password })
    if (err) {
      setError(err.message.includes('expired') || err.message.includes('invalid')
        ? 'This reset link has expired. Please request a new one.'
        : err.message)
      setSaving(false)
      return
    }
    setDone(true)
    setTimeout(() => { window.location.href = '/dashboard' }, 2500)
  }

  return (
    <AuthShell image="silhouette-faces" tagline="Pick up right where you left off." sub="Your wedding, exactly as you left it.">
      <div style={{ width:'100%', maxWidth:380 }}>
        <div style={{ textAlign:'center', marginBottom:'2rem' }}>
          <img src="/okoiya-logo.png" alt="Okoiya" style={{ height:32, marginBottom:'1.25rem' }}/>
          {done ? (
            <>
              <div style={{ width:56, height:56, background:'rgba(155,175,155,0.12)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 1rem' }}>
                <Check size={24} color="#9BAF9B"/>
              </div>
              <h1 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.5rem', color:'#1A1A1A', margin:'0 0 0.3rem' }}>Password updated!</h1>
              <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.82rem', color:'#9B9B9B', margin:0 }}>Taking you to your dashboard…</p>
            </>
          ) : (
            <>
              <h1 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.75rem', color:'#1A1A1A', margin:'0 0 0.3rem', letterSpacing:'-0.03em' }}>Set new password</h1>
              <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.82rem', color:'#9B9B9B', margin:0 }}>Choose something you'll remember.</p>
            </>
          )}
        </div>

        {!done && (
          <form onSubmit={handleReset} style={{ display:'flex', flexDirection:'column', gap:'0.875rem' }}>
            <div style={{ position:'relative' }}>
              <label style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.72rem', fontWeight:700, color:'#6B6B6B', textTransform:'uppercase', letterSpacing:'0.04em', display:'block', marginBottom:'0.3rem' }}>New Password</label>
              <input type={show?'text':'password'} className="input-field" placeholder="At least 8 characters" value={password} onChange={e=>setPassword(e.target.value)} required style={{ paddingRight:'2.5rem' }}/>
              <button type="button" onClick={()=>setShow(s=>!s)} style={{ position:'absolute', right:12, bottom:12, background:'none', border:'none', cursor:'pointer', color:'#BCBCBC' }}>
                {show ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
            <div>
              <label style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.72rem', fontWeight:700, color:'#6B6B6B', textTransform:'uppercase', letterSpacing:'0.04em', display:'block', marginBottom:'0.3rem' }}>Confirm Password</label>
              <input type={show?'text':'password'} className="input-field" placeholder="Same password again" value={confirm} onChange={e=>setConfirm(e.target.value)} required/>
            </div>
            {error && (
              <div style={{ background:'rgba(196,130,106,0.1)', border:'1px solid rgba(196,130,106,0.3)', borderRadius:'0.5rem', padding:'0.65rem 0.875rem' }}>
                <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.8rem', color:'#A86650', margin:0 }}>{error}</p>
              </div>
            )}
            <button type="submit" disabled={saving} className="btn-primary" style={{ marginTop:'0.25rem' }}>
              {saving ? 'Updating…' : 'Update Password'}
            </button>
          </form>
        )}
      </div>
    </AuthShell>
  )
}
